/**
 * [appendLeadingZeroToNumber] appends a leading zero to a number
 * @param  {Number} number - usually an array index.
 * @return {String} - string representation of input, with leading zero for input < 10.
 */
export const appendLeadingZeroToNumber = (number: number): string | number => {
  if (!Number.isInteger(number)) {
    return number;
  }

  if (number >= 10) {
    return number.toString();
  }

  return `0${number}`;
};
